"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InsuranceModel_1 = require("./InsuranceModel");
exports.default = InsuranceModel_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/InsuranceModel/index.js
// module id = 2365
// module chunks = 8